module.exports = __webpack_public_path__ + "static/media/fundorosa.eb5e67d1.svg";